export const TabStyles = ({ isHovered, isPressed, isFocused, isActive, tabMode = "dark", }) => {
    return Object.assign(Object.assign(Object.assign(Object.assign({ backgroundColor: tabMode === "dark"
            ? "#292D3B"
            : "#F9F9F9", typography: "typography.body.14.regular", color: tabMode === "dark"
            ? "color.background.constant.white"
            : "#323232", unsafe_style: { borderRadius: "2rem" }, outlineWidth: isFocused
            ? "borderWidth.1"
            : "borderWidth.none" }, (isActive && {
        backgroundColor: tabMode === "dark"
            ? "#AFB5C8"
            : "#4B4B4B", // missing gemini token
        color: tabMode === "dark"
            ? "#323232"
            : "color.background.constant.white", // missing gemini token
    })), (isHovered &&
        !isActive && {
        backgroundColor: tabMode === "dark"
            ? "#3D4459"
            : "#F9F9F9", // missing gemini token
    })), (isFocused &&
        !isActive && {
        backgroundColor: tabMode === "dark"
            ? "#3D4459"
            : "#F9F9F9", // missing gemini token
    })), (isPressed &&
        !isActive && {
        backgroundColor: tabMode === "dark"
            ? "#525A76"
            : "#F9F9F9", // missing gemini token
        outline: "none",
    }));
};
